module.exports = __webpack_public_path__ + "static/img/eyougame.adf45acc.png";